// extracted by mini-css-extract-plugin
module.exports = {"root":"G_bJ","icon":"G_cy","main-search-icon":"G_cz","mainSearchIcon":"G_cz","label-icon-default-filled":"G_cB","labelIconDefaultFilled":"G_cB"};